import React from "react";
import { Typography, Row, Col, Tooltip } from "antd";
import NumberFormat from "react-number-format";
import PriceAdjustTag from "./PriceAdjustTag";
import { adjustColor } from "./priceAdjust";
import { FONT } from "../styles/typography";

class PriceBox extends React.Component {
  render() {
    const priceType = this.props.pricetype;
    // 舊寫法檢查的是 this.props.priceType (大寫 T)，跟實際傳入的 pricetype
    // 不同名，等於從來沒生效過。
    if (!priceType) {
      return <Typography.Text type="secondary">-</Typography.Text>;
    }
    return (
      <div onClick={this.props.onHandleClick} style={{ cursor: "pointer" }}>
        <Row>
          <Col>
            <Tooltip title="目前價格">
              {priceType.currentprice !== null ? (
                <Typography.Text delete>
                  <NumberFormat
                    value={priceType.currentprice}
                    displayType="text"
                    thousandSeparator={true}
                    fixedDecimalScale={true}
                  />
                </Typography.Text>
              ) : (
                "暫無資料"
              )}
            </Tooltip>
          </Col>
        </Row>
        <Row align="middle">
          <Col>
            <Tooltip title="建議價格">
              {priceType.recommendprice !== null ? (
                <Typography.Text
                  strong
                  style={{
                    fontSize: FONT.title,
                    color: adjustColor(priceType.priceadjustrate),
                  }}
                >
                  <NumberFormat
                    value={priceType.recommendprice}
                    displayType="text"
                    thousandSeparator={true}
                    fixedDecimalScale={true}
                  />
                </Typography.Text>
              ) : (
                "暫無資料"
              )}
            </Tooltip>
          </Col>
          <Col>
            <PriceAdjustTag
              amount={priceType.priceadjust}
              rate={priceType.priceadjustrate}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
export default PriceBox;
